import React, { useState } from 'react';
import { Select, SelectContent, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Button } from '../../../components/ui/button';
import { Users, MapPin } from 'lucide-react';
import { toast } from 'sonner';
import { FormateurOptions, LieuOptions } from './SelectOptions';

// Affectation groupée : applique un formateur / un lieu à toutes les journées du planning.
export const AffectationGroupee = ({ planning, formateurs, lieux, referentId, lieuPrincipal, onPlanningChange, vue = 'tout' }) => {
  const [formateurId, setFormateurId] = useState(referentId || 'none');
  const [lieu, setLieu] = useState(lieuPrincipal || 'none');

  const applyFormateur = () => {
    const fid = formateurId === 'none' ? '' : formateurId;
    onPlanningChange(planning.map(p => ({ ...p, formateur_id: fid })));
    const f = formateurs.find(x => x.id === fid);
    toast.success(f ? `${f.nom} ${f.prenom} affecté(e) sur ${planning.length} journée(s)` : `Formateur retiré de ${planning.length} journée(s)`);
  };
  const applyLieu = () => {
    const l = lieu === 'none' ? '' : lieu;
    const jours = planning.filter(p => p.type_journee !== 'stage');
    onPlanningChange(planning.map(p => p.type_journee === 'stage' ? p : { ...p, lieu: l }));
    toast.success(l ? `Lieu « ${l} » appliqué sur ${jours.length} journée(s)` : `Lieu retiré de ${jours.length} journée(s)`);
  };

  return (
    <div className="flex flex-wrap items-center gap-2 bg-indigo-50/60 border border-indigo-100 rounded-lg px-3 py-2" data-testid="affectation-groupee">
      <span className="text-[11px] font-semibold text-indigo-700 uppercase tracking-wide mr-1">Affecter à toutes les dates</span>
      {(vue === 'tout' || vue === 'formateur') && <div className="flex items-center gap-1.5">
        <Users className="w-3.5 h-3.5 text-indigo-500" />
        <Select value={formateurId} onValueChange={setFormateurId}>
          <SelectTrigger className="h-7 text-xs w-[200px] bg-white" data-testid="bulk-formateur-select"><SelectValue placeholder="Formateur" /></SelectTrigger>
          <SelectContent><FormateurOptions formateurs={formateurs} referentId={referentId} currentId={formateurId} /></SelectContent>
        </Select>
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={applyFormateur} disabled={planning.length === 0} data-testid="bulk-formateur-apply">Appliquer</Button>
      </div>}
      {(vue === 'tout' || vue === 'lieu') && <div className="flex items-center gap-1.5">
        <MapPin className="w-3.5 h-3.5 text-indigo-500" />
        <Select value={lieu} onValueChange={setLieu}>
          <SelectTrigger className="h-7 text-xs w-[200px] bg-white" data-testid="bulk-lieu-select"><SelectValue placeholder="Lieu" /></SelectTrigger>
          <SelectContent><LieuOptions lieux={lieux} lieuPrincipal={lieuPrincipal} /></SelectContent>
        </Select>
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={applyLieu} disabled={planning.length === 0} data-testid="bulk-lieu-apply">Appliquer</Button>
      </div>}
    </div>
  );
};
